import type { InAppNotificationActions, InAppNotificationReducer } from "./types";

export default (state: InAppNotificationReducer, action: InAppNotificationActions) => {
  switch (action.type) {
    case "setInAppNotificationParams": {
      return action.payload;
    }

    case "clearState": {
      return {} as NotWorth;
    }

    default: {
      return state;
    }
  }
};
